"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.makeClassesObject = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _classNameToStyleName = _interopRequireDefault(require("./classNameToStyleName"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var makeClassesObject = function makeClassesObject(props, options) {
  var _ref;

  var code = props.code,
      _props$flip = props.flip,
      flip = _props$flip === void 0 ? '' : _props$flip,
      _props$size = props.size,
      size = _props$size === void 0 ? '' : _props$size,
      _props$squared = props.squared,
      squared = _props$squared === void 0 ? false : _props$squared,
      rotate = props.rotate,
      className = props.className,
      styleName = props.styleName;
  var themeStyles = options.themeStyles,
      useCssModules = options.useCssModules;
  return _ref = {}, _defineProperty(_ref, _constants.flagIconClassesPrefixName, true), _defineProperty(_ref, "".concat(_constants.flagIconClassesPrefix, "squared"), squared), _defineProperty(_ref, "".concat(_constants.flagIconClassesPrefix).concat(size), size), _defineProperty(_ref, "".concat(_constants.flagIconClassesPrefix).concat(code), code), _defineProperty(_ref, "".concat(_constants.flagIconClassesPrefix, "flip-").concat(flip), flip), _defineProperty(_ref, "".concat(_constants.flagIconClassesPrefix, "rotate-").concat(rotate || ''), rotate), _defineProperty(_ref, _constants.baseThemeStyleName, useCssModules && themeStyles && themeStyles[_constants.baseThemeStyleName]), _defineProperty(_ref, styleName || '', useCssModules && themeStyles && styleName && themeStyles[styleName]), _defineProperty(_ref, className || '', className), _ref;
};

exports.makeClassesObject = makeClassesObject;

var _default = function _default(props, options, styles) {
  var useCssModules = options.useCssModules;
  var classesObject = makeClassesObject(props, options);
  var strClasses = (0, _classnames.default)(classesObject);

  if (useCssModules) {
    var className = props.className;
    var aClasses = strClasses.split(' ');
    var nClasses = aClasses.length;
    strClasses = aClasses.map(function (c, i) {
      if (className && i === nClasses - 1) return c;
      return (0, _classNameToStyleName.default)(c, styles || {});
    }).join(' ');
  }

  return strClasses;
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/react-flag-icon-css/lib/functions/classnames.js
// module id = 339
// module chunks = 168707334958949